import request from '@/utils/request'

export function list (query) {
  return request({
    url: '/web/indexban/list',
    method: 'get',
    params: query
  })
}
